import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_layout/competitors/$competitorId',
)({
  // Competitors moved into the Business page; old per-competitor links land on the tab.
  beforeLoad: () => {
    throw redirect({ to: '/business', hash: 'competitors' });
  },
});
